import React from 'react';
import { Plus, Search } from 'lucide-react';

const EnseignantExterneHeader = ({ searchTerm, onSearchChange, onAddNew }) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Enseignants Externes</h2>
          <p className="text-gray-600">Gérer les enseignants externes pour les jurys</p>
        </div>
        <button
          onClick={onAddNew}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-200 flex items-center space-x-2 shadow-sm"
        >
          <Plus className="h-5 w-5" />
          <span>Nouvel Enseignant</span>
        </button>
      </div>

      {/* Barre de recherche */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
        <input
          type="text"
          placeholder="Rechercher un enseignant externe..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm"
        />
      </div>
    </div>
  );
};

export default EnseignantExterneHeader; 